const environment = getEnvironment();

let apiURL = "";
if (environment === "development") {
  apiURL =
    import.meta.env.VITE_API_URL || `http://${window.location.hostname}:8080`;
}
if (environment === "production") {
  apiURL = "https://api.volvamed.fr";
}

const SENTRY_URL = "https://sentry.selego.co/organizations/sentry/replays/";
const SENTRY_PROJECT_ID = "218";
const POSTHOG_PROJECT_TOKEN =
  "phc_qpwk9w2Gk2iXaDDbqWtJ7gos3CBAJeajg6JQxsYWWjDu";
const POSTHOG_PROJECT_ID = "241578";
const POSTHOG_HOST = "https://e.volvamed.fr";
const POSTHOG_UI_HOST = "https://eu.posthog.com";

function getEnvironment() {
  if (import.meta.env.VITE_ENVIRONMENT === "development") return "development";
  if (import.meta.env.VITE_ENVIRONMENT === "production") return "production";
  // Server rendering (app/src/entry-server.jsx) has no window: only the
  // production build runs there and it never calls the API from this module.
  if (typeof window === "undefined") return "production";
  if (
    window.location.href.indexOf("localhost") !== -1 ||
    window.location.href.indexOf("127.0.0.1") !== -1
  )
    return "development";
  return "production";
}

export {
  apiURL,
  environment,
  POSTHOG_HOST,
  POSTHOG_PROJECT_ID,
  POSTHOG_PROJECT_TOKEN,
  POSTHOG_UI_HOST,
  SENTRY_PROJECT_ID,
  SENTRY_URL,
};
